import {
  IRefreshAuthToken,
  RENEW_TOKEN_INTERVAL_MILLISECONDS
} from '../../store/ducks/auth/types';
import { EGerdauService } from '../EGerdauService';
import { ERefreshTokenEndpoints, refreshAuthTokenApi } from './api';

export interface IRefreshAuthTokenService {
  refreshAuthToken: () => Promise<IRefreshAuthToken>;
}

export class RefreshAuthTokenService
  extends EGerdauService
  implements IRefreshAuthTokenService
{
  async refreshAuthToken(): Promise<IRefreshAuthToken> {
    const headers = {
      client_id: process.env.REACT_APP_token_client_id,
      client_secret: process.env.REACT_APP_token_client_secret
    };
    const bodyRequest = {};

    const refreshAuthTokenResponse = await refreshAuthTokenApi.post(
      `${ERefreshTokenEndpoints.REFRESH_TOKEN}`,
      { ...bodyRequest },
      { headers }
    );

    try {
      const newToken = refreshAuthTokenResponse.data as IRefreshAuthToken;
      return newToken;
    } catch (err) {
      console.error(err);
      throw new Error('Não foi possível atualizar token');
    }
  }

  async checkAndRefreshToken() {
    const response = await this.refreshAuthToken();
    const azureDateTimeExpiration =
      new Date().getTime() + RENEW_TOKEN_INTERVAL_MILLISECONDS;

    RefreshAuthTokenService.setAuthorizationToken(response.access_token);
    RefreshAuthTokenService.setAuthorizationTokenExpiration(
      azureDateTimeExpiration.toString()
    );
  }
}
